import { _ as r } from "../internals/export.js";
import { o as t } from "../internals/object-is-prototype-of.js";
import { o } from "../internals/object-get-prototype-of.js";
import { o as s } from "../internals/object-set-prototype-of.js";
import { c as e } from "../internals/copy-constructor-properties.js";
import { o as a } from "../internals/object-create.js";
import { c as n } from "../internals/create-non-enumerable-property.js";
import { c as i } from "../internals/create-property-descriptor.js";
import { i as m } from "../internals/install-error-cause.js";
import { e as p } from "../internals/error-stack-install.js";
import { i as l } from "../internals/iterate.js";
import { n as c } from "../internals/normalize-string-argument.js";
import { w as f } from "../internals/well-known-symbol.js";
var j = f("toStringTag"),
  g = Error,
  y = [].push,
  u = function u(r, e) {
    var i,
      f = t(b, this);
    s ? i = s(g(), f ? o(this) : b) : n(i = f ? this : a(b), j, "Error"), void 0 !== e && n(i, "message", c(e)), p(i, u, i.stack, 1), arguments.length > 2 && m(i, arguments[2]);
    var h = [];
    return l(r, y, {
      that: h
    }), n(i, "errors", h), i;
  };
s ? s(u, g) : e(u, g, {
  name: !0
});
var b = u.prototype = a(g.prototype, {
  constructor: i(1, u),
  message: i(1, ""),
  name: i(1, "AggregateError")
});
r({
  global: !0,
  constructor: !0,
  arity: 2
}, {
  AggregateError: u
});